import { CompressOutlined, ExpandOutlined } from '@ant-design/icons';
import classnames from 'classnames';
import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useCaptureState } from '../context';

const FullScreenIcon = ({
  className = '',
  disabled,
  title,
}: {
  className?: string;
  disabled?: boolean;
  title?: string;
}) => {
  const { t } = useTranslation('Vindoc');
  const { isFullScreen, handleFullScreen } = useCaptureState();

  const Component = isFullScreen ? CompressOutlined : ExpandOutlined;

  const handleClick = useCallback(() => {
    if (disabled) return;

    handleFullScreen?.();

    const footer: HTMLDivElement = document.querySelector('.footer');
    footer.style.zIndex = !isFullScreen ? '-1' : 'initial'; //? handleFullScreen not set isFullScreen now => check !isFullScreen
  }, [disabled, handleFullScreen, isFullScreen]);

  return (
    <Component
      title={disabled ? t('Please allow access to your camera and microphone') : title}
      disabled={disabled}
      onClick={handleClick}
      className={classnames('p-3 pr-0 pl-4 text-[26px] drop-shadow-lg', className, {
        'cursor-not-allowed opacity-50': disabled,
        'sm:text-[20px] lg:text-[28px]': isFullScreen,
      })}
    />
  );
};

export default memo(FullScreenIcon);
